const ServerSideInputs = () => {
  return <input name="sent_from_orchid" type="hidden" value="true" />;
};

export default ServerSideInputs;
